export const MAX_PHONE_NUM = ['+380982204411', '+380982204411'];
export const NAZAR_PHONE_NUM = ['+380953249075'];
export const EV_TUNING_PHONE_NUM = ['+380730878007'];
